import React from "react";
import styles from "../../static/css/pages.module.css";
import Header from "../../components/header/priv/header";
import Footer from "../../components/footer/footer";
import PageSettings from "../profile/profile";
import PanelHistory from "../income/income";
import RegisterIncome from "../income/register";
import RegisterClient from "../clients/register";
import PanelNotifications from "../notifications/notifications";
import PanelClients from "../clients/clients";
import ServerError from "../server/error";
import PanelInfo from "../info/list";
import ieSvg from "../../components/icons/ieSvg";
import PanelTaxes from "../taxes/list";
import Sidebar from "./sidebar/sidebar";
import {connect} from "react-redux";
import Banner from "./banner";
import ServerRegister from "../server/register";

class PageHome extends React.Component {
  componentDidMount() {
    if(window.location.href.indexOf("?page=registerNow") > -1) {
      window.location.href = process.env.PUBLIC_URL + '/page/home';
    }
  }

  componentDidUpdate() {
    ieSvg();
  }

  render() {
    return (
      <main>
        <Header />
        {this.props.banner?
          <Banner />
          :
          null
        }
        <section className={styles.section}>
          <div className="inner">
            <div className="l-grid">
              <div className="l-grid__item_4 section-menu">
                <Sidebar />
              </div>
              <div className="l-grid__item_8">
                {this.props.menu.items ?
                  this.props.menu.items.map((item, i) =>
                    item.current ?
                      <PageHomeInner key={i} page={item.value} />
                      :
                      null
                  )
                  : null }
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    )
  }
}

class PageHomeInner extends React.Component {
  componentDidMount() {
    document.querySelector("body").classList.remove('visible-menu');
    window.addEventListener("popstate", function(e) {
      window.location.reload()
    });
  }

  render() {
    switch (this.props.page) {
      case "taxes":               return <PanelTaxes />;
      case "home":                return <PanelHistory />;
      case "registerIncome":      return <RegisterIncome />;
      case "clients":             return <PanelClients />;
      case "registerClient":      return <RegisterClient />;
      case "notifications":       return <PanelNotifications />;
      case "settings":            return <PageSettings />;
      case "information":         return <PanelInfo />;
      case "needRegister":        return <ServerRegister pageTitle="Данные не получены." pageIcon="icon_menu-clients" />;
      default:                    return <ServerError pageTitle="Что-то пошло не так"  pageIcon="icon_menu-operations" errorMessage="Сервис временно недоступен" />;
    }
  }
}

const mapStateToProps = state => ({menu: state.sidebarNav});

export default connect(mapStateToProps)(PageHome);
